import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSWholeWheatNaanProduct from 'models/BSWholeWheatNaanProduct'
import BSWholeWheatNaanPackage from './BSWholeWheatNaanPackage'

const productOptions = {
  packagingInfo: <BSWholeWheatNaanPackage />,
  productTitle: 'Brand Specific Whole Wheat Naan',
  model: BSWholeWheatNaanProduct,
  validCategories: ['16'],
  validSubCategories: ['013'],
  brandSpecific: true,
}

const BSWholeWheatNaan = () => <ProductForm product={productOptions} />

export default BSWholeWheatNaan
